import {Duration, Equipment, Experience, Game, GamePlayers} from "../types";

export const PRESENTATION_GAME = new Game(
    'presentation',
    new GamePlayers(1, 1),
    [Equipment.SCREEN],
    Duration.MEDIUM,
    Experience.INTERMEDIATE,
    true
);

export const CONDUCTED_STORY_GAME = new Game(
    'conducted-story',
    new GamePlayers(2, undefined),
    [Equipment.SCREEN],
    Duration.SHORT,
    Experience.BEGINNER,
    true
);

export const INTERVIEW_GAME = new Game(
    'interview',
    new GamePlayers(3, undefined),
    [],
    Duration.LONG,
    Experience.BEGINNER,
    true
);

export const LINES_GAME = new Game(
    'lines',
    new GamePlayers(5, undefined),
    [],
    Duration.MEDIUM,
    Experience.INTERMEDIATE,
    true
);

export const INTERESTING_DISCUSSION_GAME = new Game(
    'interesting-discussion',
    new GamePlayers(2, undefined),
    [],
    Duration.MEDIUM,
    Experience.BEGINNER,
    true
);

export const QUESTIONS_GAME = new Game(
    'questions',
    new GamePlayers(2, 2),
    [],
    Duration.SHORT,
    Experience.BEGINNER,
    true
);

export const ONE_WORD_STORY_GAME = new Game(
    'one-word-story',
    new GamePlayers(2, undefined),
    [],
    Duration.MEDIUM,
    Experience.BEGINNER,
    true
);

export const ONE_VOICE_GAME = new Game(
    'one-voice',
    new GamePlayers(3, 3),
    [],
    Duration.MEDIUM,
    Experience.INTERMEDIATE,
    false
);

export const CONFESSIONS_GAME = new Game(
    'confessions',
    new GamePlayers(3, 3),
    [],
    Duration.MEDIUM,
    Experience.INTERMEDIATE,
    false
);

export const GAMES = [PRESENTATION_GAME, CONDUCTED_STORY_GAME, INTERVIEW_GAME, INTERESTING_DISCUSSION_GAME, LINES_GAME, QUESTIONS_GAME, ONE_VOICE_GAME, ONE_WORD_STORY_GAME, CONFESSIONS_GAME];

export const getParticipants = (players: GamePlayers):string => {
    if (players.min === players.max) return players.min + '';

    if (players.max === undefined) {
        if (players.min === 0) return "*";
        else return  players.min + "+"
    } else {
        if (players.min === 0) return "±" + players.max;
        else return players.min + " - " + players.max;
    }
};
